module.exports = __webpack_public_path__ + "static/media/Logo 4.90a24a7d.png";